module.exports = __webpack_public_path__ + "c23a5ab11f82798b7ee028126f5492cb.png";